import { createReducerUsingActionHandlers, SUCCESS, } from '@travel-frontend/state-handling-sdk';
import { FETCH_USER_ID } from '../redux/actions.js';
const initialState = {};
const actionCreators = {
    [SUCCESS(FETCH_USER_ID)]: (state, action) => ({
        ...state,
        data: action.data,
    }),
};
export const userIdReducer = createReducerUsingActionHandlers(initialState, actionCreators);
//# sourceMappingURL=reducer.js.map